import React, { useState, useEffect } from "react";
import { Link, useNavigate } from "react-router-dom";
import ArrowBackIcon from "@mui/icons-material/ArrowBack";
import SearchIcon from "@mui/icons-material/Search";
import {
  Paper,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TablePagination,
  TableHead,
  TableRow,
  Typography,
  Select,
  Box,
} from "@mui/material";
import "./SFGstore.css";
import { getSFGClassSizeSummary, getSFGStoreData } from "./services";
import { images } from "../../config/images";
import { getParingLength } from "../GlovesPairing/services";

const SFGstore = () => {
  const navigate = useNavigate();
  const [debouncedSearchText, setDebouncedSearchText] = useState({});
  const [page, setPage] = React.useState(0);
  const [rowsPerPage, setRowsPerPage] = React.useState(10);
  const [insulatingData, setInsulatingData] = useState([]);
  const [compositeData, setCompositeData] = useState([]);
  const [GlovesLength, setGlovesLength] = useState([]);

  const data = [
    { class: "00", size: 3, length: 380, type: "SC", quantity: 825 },
    { class: "1", size: 9, length: 420, type: "RE", quantity: 760 },
    { class: "2", size: 10, length: 380, type: "SC", quantity: 825 },
    { class: "3", size: 11, length: 420, type: "RE", quantity: 760 },
  ];
  const inputStyle = {
    border: "1px solid #ccc",
    borderRadius: "4px",
    padding: "8px",
    boxSizing: "border-box", 
    marginTop: "-2px",
  };
  const initiallValue = {
    class_id__class_name: "",
    size__size_name: "",
    length__length: "",
    scre_type: "",
    quantity: "",
  };

  const [searchText, setSearchText] = useState(initiallValue);
  const [insulatingGlovesLength, setInsulatingGlovesLength] = useState("");
  const [compositeGlovesLength, setCompositeGlovesLength] = useState("");
  useEffect(() => {
    const handler = setTimeout(() => {
      setDebouncedSearchText(searchText);
    }, 500);

    return () => {
      clearTimeout(handler);
    };
  }, [searchText]);

  const handleSearchData = async (e) => {
    const { name, value } = e.target;
    setSearchText({ ...searchText, [name]: value });
  };

  const handleChangePage = (event, newPage) => {
    setPage(newPage);
  };

  const handleChangeRowsPerPage = (event) => {
    setPage(0);
    setRowsPerPage(parseInt(event.target.value, 10));
  };

  const fetchData = async (glovesType, length) => {
    try {
      const params = {};
      if (glovesType) {
        params.gloves_type = glovesType;
      }
      if (length) {
        params.length = length;
      }

      const response = await getSFGClassSizeSummary(params);
      if (response.data.success) {
        if (glovesType === "Insulating") {
          setInsulatingData(response.data.payload.Insulating);
        } else if (glovesType === "Composite") {
          setCompositeData(response.data.payload.Composite);
        }
      }
    } catch (error) {
      console.log(error);
    }
  };

  useEffect(() => {
    fetchData("Insulating", insulatingGlovesLength);
  }, [insulatingGlovesLength]);

  useEffect(() => {
    fetchData("Composite", compositeGlovesLength);
  }, [compositeGlovesLength]);

  useEffect(() => {
    handleGetLength();
  }, []);

  const handleGetLength = async () => {
    try {
      const resp2 = await getParingLength();
      setGlovesLength(resp2.data);
    } catch (error) {
      console.log(error);
    }
  };

  return (
    <div className="dashboard-wrapper page-wraper">
      <div className="page-header">
        <Link to="/dashboard" className="page-back-btn">
          <ArrowBackIcon />
          <span>SFG Store</span>
        </Link>
        <div className="d-flex gap-2">
          <button
            className="page-header-btn-params"
            style={{ fontSize: "17px" }}
            onClick={() => navigate("/sfg-inventory")}
          >
            Inventory
          </button>
          <button
            className="page-header-btn-params"
            style={{ fontSize: "17px" }}
            onClick={() => navigate("/sfg-box-storage")}
          >
            SFG Box Storage
          </button>
          <button
            className="page-header-btn-params"
            style={{ fontSize: "17px" }}
            onClick={() => navigate("/sfg-entry")}
          >
            SFG Entry +
          </button>
        </div>
      </div>
      <Box
        sx={{
          display: "flex",
          justifyContent: "space-between",
          alignItems: "center",
        }}
      >
        <Typography variant="h6">Insulating Gloves</Typography>
        <select
          value={insulatingGlovesLength}
          onChange={(e) => setInsulatingGlovesLength(e.target.value)}
          style={{
            ...inputStyle,
            color: insulatingGlovesLength ? "#000" : "gray",
          }}
        >
          <option value="">Select Length</option>
          {GlovesLength && GlovesLength.length > 0 ? (
            GlovesLength.map((element) => (
              <option key={element.length} value={element.length}>
                {element.length}
              </option>
            ))
          ) : (
            <option disabled>No Data Found</option>
          )}
        </select>
      </Box>

      <div className="pt-2 table-responsive">
        <TableContainer component={Paper}>
          <Table className="sfg-score-table">
            <TableHead>
              <TableRow style={{ backgroundColor: "#1c447c" }}>
                <TableCell style={{ color: "#fff" }}>Class</TableCell>
                <TableCell style={{ color: "#fff" }}>Size 7</TableCell>
                <TableCell style={{ color: "#fff" }}>Size 8</TableCell>
                <TableCell style={{ color: "#fff" }}>Size 9</TableCell>
                <TableCell style={{ color: "#fff" }}>Size 10</TableCell>
                <TableCell style={{ color: "#fff" }}>Size 11</TableCell>
                <TableCell style={{ color: "#fff" }}>Size 12</TableCell>
              </TableRow>
            </TableHead>
            <TableBody>
              {insulatingData?.map((row, index) => (
                <TableRow
                  key={index}
                  style={index % 2 ? { backgroundColor: "#f9f9f9" } : null}
                >
                  <TableCell>Class {row.class}</TableCell>
                  <TableCell>{row["Size 7"] || 0}</TableCell>
                  <TableCell>{row["Size 8"] || 0}</TableCell>
                  <TableCell>{row["Size 9"] || 0}</TableCell>
                  <TableCell>{row["Size 10"] || 0}</TableCell>
                  <TableCell>{row["Size 11"] || 0}</TableCell>
                  <TableCell>{row["Size 12"] || 0}</TableCell>
                </TableRow>
              ))}
            </TableBody>
          </Table>
        </TableContainer>
      </div>

      <Box
        sx={{
          display: "flex",
          justifyContent: "space-between",
          alignItems: "center",
          pt: 5,
        }}
      >
        <Typography variant="h6">Composite Gloves</Typography>
        <select
          value={compositeGlovesLength}
          onChange={(e) => setCompositeGlovesLength(e.target.value)}
          style={{
            ...inputStyle,
            color: compositeGlovesLength ? "#000" : "gray",
          }}
        >
          <option value="">Select Length</option>
          {GlovesLength && GlovesLength.length > 0 ? (
            GlovesLength.map((element) => (
              <option key={element.length} value={element.length}>
                {element.length}
              </option>
            ))
          ) : (
            <option disabled>No Data Found</option>
          )}
        </select>
      </Box>

      <div className="pt-2 table-responsive">
        <TableContainer component={Paper}>
          <Table className="sfg-score-table">
            <TableHead>
              <TableRow style={{ backgroundColor: "#1c447c" }}>
                <TableCell style={{ color: "#fff" }}>Class</TableCell>
                <TableCell style={{ color: "#fff" }}>Size 7</TableCell>
                <TableCell style={{ color: "#fff" }}>Size 8</TableCell>
                <TableCell style={{ color: "#fff" }}>Size 9</TableCell>
                <TableCell style={{ color: "#fff" }}>Size 10</TableCell>
                <TableCell style={{ color: "#fff" }}>Size 11</TableCell>
                <TableCell style={{ color: "#fff" }}>Size 12</TableCell>
              </TableRow>
            </TableHead>
            <TableBody>
              {compositeData?.map((row, index) => (
                <TableRow
                  key={index}
                  style={index % 2 ? { backgroundColor: "#f9f9f9" } : null}
                >
                  <TableCell>Class {row.class}</TableCell>
                  <TableCell>{row["Size 7"] || 0}</TableCell>
                  <TableCell>{row["Size 8"] || 0}</TableCell>
                  <TableCell>{row["Size 9"] || 0}</TableCell>
                  <TableCell>{row["Size 10"] || 0}</TableCell>
                  <TableCell>{row["Size 11"] || 0}</TableCell>
                  <TableCell>{row["Size 12"] || 0}</TableCell>
                </TableRow>
              ))}
            </TableBody>
          </Table>
        </TableContainer>
      </div>
    </div>
  );
};

export default SFGstore;